var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import { Field } from 'react-redux-form';
import { Icon } from "../../UI";
import React from 'react';
import { FormGroup } from "../../Forms";
import { LocalForm } from "../../Forms/Form";
import { Translate, t } from "../../I18N";








const WebMediaResourceForm = ({
  handleSubmit,
  url,
  dispatch,
  hasName = false
}) => {
  const validators = _objectSpread(_objectSpread({},
  hasName && { name: { required: (val) => !!val && val.trim() !== '' } }), {}, {
    url: { required: (val) => !!val && val.trim() !== '' } });


  return (/*#__PURE__*/
    _jsx(LocalForm, {
      onSubmit: handleSubmit,
      getDispatch: dispatch,
      model: "urlForm",
      validators: validators,
      initialState: { url },
      className: !hasName ? 'select-from-link' : '' }, void 0, /*#__PURE__*/

    _jsx(FormGroup, { className: "has-feedback", model: ".url" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: ".url" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      className: "form-control web-attachment-url",
      placeholder: t('System', 'Paste URL here', null, false) }
    )
    )
    ),
    hasName && /*#__PURE__*/
    _jsx(FormGroup, { className: "form-group", model: ".name" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: ".name", className: "field" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      className: "form-control web-attachment-name",
      placeholder: t('System', 'Title', null, false) }
    )
    )
    ), /*#__PURE__*/

    _jsx("button", { type: "submit", className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "link" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add from URL")
    )
    ));

};

export { WebMediaResourceForm };